import React from 'react';

export default function ReportGenerator({ data, type, fileName }) {
  const generatePDF = () => {
    try {
      let content = '';

      if (type === 'gains') {
        const summary = data.summary || {};
        content = `
FLEXFLOW PRO - REPORTE DE GANANCIAS
Generado: ${new Date().toLocaleDateString('es-CO')}

RESUMEN:
Total Prestado: $${((summary.total_loaned || 0) / 1000000).toFixed(2)}M
Total Ganado: $${((summary.total_gains || 0) / 1000000).toFixed(2)}M
Total Clientes: ${summary.total_clients || 0}

TOP CLIENTES:
${data.clients ? data.clients.slice(0, 10).map((c, i) =>
  `${i + 1}. ${c.name} - Prestado: $${((c.total_loaned || 0) / 1000000).toFixed(2)}M - Ganado: $${((c.total_gains || 0) / 1000000).toFixed(2)}M`
).join('\n') : 'Sin datos'}
        `;
      } else if (type === 'cobranza') {
        content = `
FLEXFLOW PRO - REPORTE DE COBRANZA
Generado: ${new Date().toLocaleDateString('es-CO')}

RESUMEN:
Total Préstamos: ${data.rate?.total_loans || 0}
Con Pagos Registrados: ${data.rate?.loans_with_payment || 0}
Tasa de Cobro: ${data.rate?.collection_rate || 0}%

TOP PAGADORES:
${data.topPayers ? data.topPayers.slice(0, 10).map((p, i) =>
  `${i + 1}. ${p.name} - Pagos: ${p.payment_count} - Total: $${((p.total_paid || 0) / 1000000).toFixed(2)}M`
).join('\n') : 'Sin datos'}
        `;
      }

      // Crear blob y descargar
      const blob = new Blob([content], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}.txt`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error:', err);
      alert('Error al generar reporte');
    }
  };

  return (
    <button
      onClick={generatePDF}
      style={{
        padding: '10px 20px',
        backgroundColor: '#667eea',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '14px',
        marginLeft: '10px',
        transition: 'all 0.3s',
        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
      }}
      onMouseEnter={(e) => e.target.style.backgroundColor = '#5568d3'}
      onMouseLeave={(e) => e.target.style.backgroundColor = '#667eea'}
      title="Descargar reporte"
    >
      📄 Descargar Reporte
    </button>
  );
}
